<button mat-icon-button (click)="show = !show" [matTooltip] = "info | translate">
    <mat-icon>help_outline</mat-icon>
</button>

<ng-container *ngIf = "show">
    
    <div class="alert alert-secondary mt-3">

        <ng-container *ngIf="description">
            <div class = "mt-3">
                <b><span translate>help.description</span></b>
                
                <br>
                <div class = 'dropdown-divider'></div>
                
                <span [innerHTML]="description | translate"></span>
                
                <br>
                <div class = 'dropdown-divider'></div>

                <br>
                <br>
            </div>    
        </ng-container>

        <ng-container *ngIf="action">
            <div class = "mt-3">
                <b><span translate>help.action</span></b>
                
                <br>
                <div class = 'dropdown-divider'></div>
                
                <span *ngFor="let item of action | translate"><span [innerHTML] = "item"></span></span>
                
                <br>
                <div class = 'dropdown-divider'></div>

                <br>
                <br>
            </div>    
        </ng-container>

        <div class = "mt-3">
            <span *ngFor="let item of text | translate"><span [innerHTML] = "item"></span></span>
        </div>
    </div>

</ng-container>